import { isLocalStorage, isIncognito } from './_Utils';

const zipCheck = () => {
    function showZipError(currentForm) {
        currentForm.find('button[type="submit"]').removeClass('active');

        $('.ball-spin-fade-loader').removeClass('active');
        $('.geo-zip__button').removeClass('btn-spin').addClass('btn-active');

        let errorText = 'Zip code not found';
        if (currentForm.hasClass('change-zip-form')) {
            errorText = '!';
        }

        currentForm
            .find('label.error')
            .text(errorText)
            .removeClass('hidden')
            .show();
    }

    function showAddressError(currentForm) {
        currentForm.find('button[type="submit"]').removeClass('active');

        $('.ball-spin-fade-loader').removeClass('active');
        $('.geo-zip__button').removeClass('btn-spin').addClass('btn-active');

        let errorText = 'Please select a valid address.';
        if (currentForm.hasClass('change-zip-form')) {
            errorText = '!';
        }

        currentForm
            .find('label.error')
            .text(errorText)
            .removeClass('hidden')
            .show();
    }

    // iOS fix for back button cache
    $(window).bind('pageshow', (e) => {
        if (e.originalEvent.persisted) {
            $('.zip-finder button[type="submit"]').removeClass('active');
            $('.ball-spin-fade-loader').removeClass('active');
        }
    });

    // $('.zip-finder').on('submit', e => {
    $(document).on(
        'submit',
        '.zip-finder:not(.provider-availability-form)',
        (e) => {
            e.preventDefault();

            const currentForm = $(e.currentTarget);

            if (currentForm.valid()) {
                const zipInput = currentForm.find('input[name="zip"]');
                let zipCode = '';
                if (zipInput.attr('data-type') === 'address') {
                    zipCode = zipInput.attr('data-zip');
                } else {
                    zipCode = zipInput.val();
                }

                if (!zipCode) {
                    showAddressError(currentForm);
                    return;
                }

                currentForm.find('button[type="submit"]').addClass('active');

                const speed = currentForm.find('input[name="speed"]').val();
                const tab = currentForm.find('input[name="tab"]').val();
                const redirect = currentForm
                    .find('input[name="redirect"]')
                    .val();
                const hideProvider = currentForm.find('input[name="n"]').val();
                const top = currentForm.find('input[name="top"]').val();

                let uri = '/';

                $.ajax({
                    success: (res) => {
                        if (
                            !res ||
                            typeof res.error !== 'undefined' ||
                            res === false ||
                            res.errors
                        ) {
                            showZipError(currentForm);
                            return true;
                        }

                        // store the zip code for the user
                        if (isLocalStorage() && !isIncognito()) {
                            localStorage.setItem('zip', zipCode);
                        }

                        let resState = '';
                        let resCities = '';

                        if ('data' in res) {
                            resCities = res.data.validateZipCode.cities[0].city;
                            resState = res.data.validateZipCode.cities[0].state;
                        } else {
                            resCities = res.cities[0].slug;
                            resState = res.cities[0].state;
                        }

                        const samePageRedirect =
                            document.querySelector('[data-redirect]');

                        if (
                            zipCode &&
                            $('input[name="page"]').val() === 'widget'
                        ) {
                            // we're on the widget
                            let widgetVars = '';
                            if ($('input[name="widget-vars"]').val() !== '') {
                                widgetVars = $(
                                    'input[name="widget-vars"]'
                                ).val();
                            }
                            uri = `/widget?zip=${zipCode}&${widgetVars}`;
                        } else if (typeof redirect !== 'undefined') {
                            // redirect page option set
                            uri = `/${redirect}?zip=${zipCode}`;
                        } else if (samePageRedirect) {
                            uri = `${window.location.pathname}?zip=${zipCode}`;
                        } else if (resCities && resState) {
                            // redirect to the city page

                            if (window.location.pathname.includes('/es/')) {
                                uri = `${uri}es/`;
                            }

                            uri = `${
                                uri + resState.toLowerCase()
                            }/${resCities}?zip=${zipCode}`;

                            if (speed) {
                                // save speed value from How Much Speed Do You Need tool
                                uri = `${uri}&speed=${speed}`;
                            }
                            if (tab) {
                                uri = `${uri}&${tab}`;
                            }
                        } else if (zipCode && zipCode >= 4) {
                            if (speed) {
                                // save speed value from How Much Speed Do You Need tool
                                uri = `${uri}&speed=${speed}`;
                            }
                            if (tab) {
                                uri = `${uri}&${tab}`;
                            }
                            uri = `${uri}in-your-area?zip=${zipCode}`; // send to in your area
                        } else if (res.statusCode && res.statusCode === 404) {
                            uri = `${uri}in-your-area`;
                        }

                        if (hideProvider) {
                            uri = `${uri}&n=${hideProvider}`;
                        }

                        if (top) {
                            uri = `${uri}&t=${top}`;
                        }

                        window.location.href = uri;
                        return true;
                    },
                    dataType: 'json',
                    url: `/wp/wp-admin/admin-ajax.php?action=zipcheck&zip=${zipCode}`,
                    error: () => {
                        showZipError(currentForm);
                    },
                });
            }
        }
    );

    let checkConn = '';

    function checkConnectionType() {
        if (
            localStorage.getItem('MM_CONNECTION_TYPE') === 'Cable/DSL' ||
            localStorage.getItem('MM_CONNECTION_TYPE') === 'Corporate'
        ) {
            $('.find-zip__tooltip').show();
            clearInterval(checkConn);
        } else if (localStorage.getItem('MM_CONNECTION_TYPE') === 'Cellular') {
            clearInterval(checkConn);
        }
    }

    if (isLocalStorage() && !isIncognito()) {
        checkConn = setInterval(checkConnectionType, 100);
    }
    let zipInput = $('.zip:first');

    $('.find-zip').click((e) => {
        zipInput = $(e.currentTarget).parent().next('input');
        const oGPlaceholder = zipInput.attr('placeholder');
        zipInput.attr('placeholder', 'Finding ZIP...');
        // random time between 200 and 666
        const randomTime = Math.floor(Math.random() * 466 + 200);
        zipInput.focus();
        setTimeout(() => {
            zipInput
                .val(localStorage.getItem('MM_ZIP'))
                .attr('placeholder', oGPlaceholder);
        }, randomTime);
    });
};

// Export public methods
export { zipCheck };
